import { createStore } from 'satcheljs';
import type { DropViewState } from 'owa-dnd';
import type { AssetId } from 'owa-timestream-store';

export default createStore('timeStreamCanvasViewState', {
    hasDraggedFarEnough: false,
    assetOffset: null as { dx: number; dy: number } | null,
    pan: { x: 0, y: 0 },
    panOffset: null as { dx: number; dy: number } | null,
    selectedAssets: [] as AssetId[],
    zoom: 1,
    dropViewState: { isDragOver: false, draggableItemType: '' } as DropViewState,
    showMiniMap: false,
    showZoomTools: false,
    zoomToolsHasFocus: false,
    canvasBounds: { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 },
    hoveringBucket: false,
    isUsingToolbox: true,
    showProjectsToolbox: false,
    lastScrollTime: Date.now(),
    enableLock: false,
    isLocked: false,
});
